import { Grid } from "@mui/material";
import React, { FC } from "react";
import { useEffect } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";
import { SearchServiceCommand } from "../../../services/command";
import TimeHelper from "../../../utils/time";
import { LWD } from './lcwaikikiDashboard.classes';
interface IProps {
  executionDate?: any;
  type?: any;
  value?: any;
}
export const LcwaikikiDashboard: FC<IProps> = ({
  executionDate,
  type,
  value,
}) => {
  const [arrays, setArrays] = React.useState([]);
  const GetSummariesHistory = async () => {
    let params = {
      Type: type,
      Value: value,
      ExecutionDate: executionDate,
    };
    SearchServiceCommand.GetSummariesHistory(params)
      .then((res: any) => {
        if (res) {
          let parseData = res.summaryHistories.map((item: any) => {
            return {
              Name: item.type || "-",
              value: item.value || " ",
              executionDate:
                TimeHelper.formatDateHour(item.executionDate) || " ",
              totalQuantity: item.series.totalQuantity || " ",
              totalReservedQuantity:
                item.series.totalReservedQuantity * 1000 || " ",
            };
          });
          setArrays(parseData);
        }
      })
      .catch((error: any) => {
        console.log("Hata :>> ", error);
      });
  };

  useEffect(() => {
    GetSummariesHistory();
  }, [executionDate]);

  return (
    <Grid className={LWD.root} data-chart-type={String(type ?? '')}>
      <LineChart
        className={LWD.chart}
        width={600}
        height={300}
        data={arrays}
        margin={{
          top: 5,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
          dataKey="executionDate"
          tickLine={false}
          tick={{ fontSize: 8 }}
          angle={-45}
          textAnchor="end"
          interval={0}
          width={5}
        />
        <YAxis type="number" />
        <Tooltip />
        <Legend wrapperStyle={{ top: -25, left: 25 }} />
        <Line
          type="monotone"
          dataKey="totalReservedQuantity"
          name="totalReservedQuantity*(1000)"
          stroke="#82ca9d"
        />
        <Line
          type="monotone"
          dataKey="totalQuantity"
          stroke="#8884d8"
          activeDot={{ r: 15 }}
        />
      </LineChart>
    </Grid>
  );
};
